import { render, staticRenderFns } from "./Detalhe_Titular.vue?vue&type=template&id=d35fb31a&"
import script from "./Detalhe_Titular.vue?vue&type=script&lang=js&"
export * from "./Detalhe_Titular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports